import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {NotificationsGqlModel} from "./notifications.gql-model";
import {exposePropertyInDebugMode} from "../misc/expose-item-in-debug-mode.function";
import {Apollo} from "apollo-angular";

@Injectable({providedIn: "root"})
export class NotificationsService {
  private notificationsSubject: BehaviorSubject<NotificationsGqlModel[]> =
    new BehaviorSubject<NotificationsGqlModel[]>([]);

  notifications: Observable<NotificationsGqlModel[]> = this.notificationsSubject.asObservable();

  constructor(private apollo: Apollo) {
    const subject = this.notificationsSubject;

    exposePropertyInDebugMode("notificationsSubject", {
      enumerable: true,
      configurable: true,
      get() { return subject; },
    });

    this.notifications.subscribe(
      () => {},
      (error) => { console.error(error); },
    );
  }

  init() {
    const query = NotificationsGqlModel.query;

    this.apollo.subscribe({query, fetchPolicy: "no-cache"})
      .pipe(NotificationsGqlModel.mapper)
      .subscribe(this.notificationsSubject);
  }
}
